import { useEmitAnalyticsEvent } from "@unlikelystudio/react-ecommerce-hooks"

import type { CustomEvents } from "~/hooks/tracking/useEmitCustomAnalyticsEvent/types"

export function useEmitCustomAnalyticsEvent() {
  const emitEvent = useEmitAnalyticsEvent()

  function emitCustomEvent<EventType extends keyof CustomEvents>(event: EventType, payload: CustomEvents[EventType]) {
    // TODO: improve abstracts with custom types
    // @ts-expect-error
    emitEvent(event, payload)
  }

  return { emitCustomEvent }
}
